import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {RoutesEnums} from '../../../enums/RoutesEnums';
import {MetaTag} from '../../../types/MetaTag';
import {MetaTypesEnum} from '../../../enums/SeoEnums';
import {SearchState} from '../../../types/SearchState';
import {QueryParams} from '../../../types/QueryParams';
import {SeoMetaService} from '../../../services/seo-meta.service';
import {LinkService} from '../../../services/link.service';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {AppConfigService} from '../../../services/app-config.service';

@Injectable()
export class SearchMetaTagsService {
  constructor(
    private metaService: SeoMetaService,
    private linkService: LinkService,
    private urlBuilderService: UrlBuilderService,
    private tools: ToolsService,
    private appConfigService: AppConfigService,
  ) {}

  public updateLinkMetaTags(page: number, totalPages: number, searchState: SearchState): void {
    const baseUrl: string[] = [RoutesEnums.SEARCH];
    if (page > 1) {
      const prevState = this.tools.clone(searchState);
      prevState.page--;
      this.linkService.updateTag({
        rel: 'prev',
        href: `${this.generateUrlFromSearchState(prevState, baseUrl)}`,
      });
    }

    if (page < totalPages) {
      const nextState = this.tools.clone(searchState);
      nextState.page++;
      this.linkService.updateTag({
        rel: 'next',
        href: `${this.generateUrlFromSearchState(nextState, baseUrl)}`,
      });
    }
  }

  public updateCanonicalTag(searchState: SearchState): void {
    const baseUrl: string[] = [RoutesEnums.SEARCH];
    const firstPageState = this.tools.clone(searchState);
    firstPageState.page = 1;
    const canonical: string = `${this.generateUrlFromSearchState(firstPageState, baseUrl)}`;
    this.linkService.removeTag({rel: 'canonical'});
    this.linkService.updateTag({
      rel: 'canonical',
      href: canonical,
    });
  }

  public updateNoIndexTag(noIndex: boolean): void {
    const metaTags: MetaTag[] = [];
    metaTags.push({
      value: noIndex ? 'noindex,nofollow' : 'index',
      type: MetaTypesEnum.NAME,
      field: 'robots',
    });
    metaTags.push({
      value: this.appConfigService.appConfig.siteName,
      type: 'property',
      field: 'og:site_name',
    });
    this.metaService.updateMetaTags(metaTags);
  }

  private generateUrlFromSearchState(state: SearchState, baseUrl: string[]): string {
    let url: string = this.urlBuilderService.CreateSearchResultsRouterLink(state, baseUrl).join('/');
    const queryParams: QueryParams = this.urlBuilderService.CreateSearchResultsQueryParams(state);
    const queryParamsCombined: string[] = [];
    const paramsKeys: string[] = Object.keys(queryParams).filter((value) => typeof value === 'string') as string[];
    paramsKeys.forEach((key) => {
      queryParamsCombined.push(`${key}=${queryParams[key]}`);
    });
    if (queryParamsCombined.length > 0) {
      url += `?${queryParamsCombined.join('&')}`;
    }
    return `${this.appConfigService.appConfig.baseUrl}${url}`;
  }
}
